import { useCallback } from 'react';
import { callDeepLink } from '@croquiscom-pvt/web2app';
import { useRouter } from 'next/router';

import { useZigzag } from '@common/device-manager';

import { ZigzagEvent } from '../ZigzagEvent';
import { TransitionOptions, ZPayFnOptions } from './types';
import { handleRouteForZPay } from './utils';

import { UrlObject } from 'url';

export const useZigzagRouter = () => {
  const router = useRouter();
  const is_app = useZigzag();

  const push = useCallback(
    (url: string | UrlObject, zpayFnOptions: ZPayFnOptions = {}, options?: TransitionOptions) => {
      handleRouteForZPay(url, {
        disable_zpay_function: false,
        ...zpayFnOptions,
      })(() => {
        router.push(url, url, options);
      });
    },
    [router],
  );

  const replace = useCallback(
    (url: string | UrlObject, zpayFnOptions: ZPayFnOptions = {}, options?: TransitionOptions) => {
      handleRouteForZPay(url, {
        disable_zpay_function: false,
        ...zpayFnOptions,
      })(() => {
        router.replace(url, url, options);
      });
    },
    [router],
  );

  const open = useCallback((url: string | UrlObject, zpayFnOptions: ZPayFnOptions = {}) => {
    handleRouteForZPay(url, {
      disable_zpay_function: false,
      ...zpayFnOptions,
    })(() => {
      window.open(url as string, '_blank');
    });
  }, []);

  const openFullScreenSimpleBrowser = useCallback(
    (pathname: string) => {
      const href = window.location.origin + pathname;
      if (is_app) {
        callDeepLink('/full_screen_simple_browser')({
          url: encodeURIComponent(href),
        });
      } else {
        window.open(href, '_blank');
      }
    },
    [is_app],
  );

  const backFullScreenSimpleBrowser = useCallback(() => {
    if (is_app) {
      ZigzagEvent.back();
    } else {
      window.close();
    }
  }, [is_app]);

  const closeFullScreenSimpleBrowser = useCallback(() => {
    if (is_app) {
      ZigzagEvent.back();
    } else {
      window.close();
    }
  }, [is_app]);

  return {
    push,
    replace,
    open,
    openFullScreenSimpleBrowser,
    backFullScreenSimpleBrowser,
    closeFullScreenSimpleBrowser,
  };
};
